import React, { useEffect, useState } from 'react';
import axios from 'axios';

const DepositLedgerTab = ({ username, fromDate, toDate }) => {
  const [deposits, setDeposits] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  username = localStorage.getItem("farmerUsername") || "F-A-3";
  // const API_BASE = process.env.REACT_APP_API_URL;
  

  useEffect(() => {
    if (!username || !fromDate || !toDate) {
      setError("Username, fromDate, and toDate are required.");
      setLoading(false);
      return;
    }

    const fetchDeposits = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/deposit-ledger`, // ✅ बरोबर variable
          {
            username: username,
            from_date: fromDate,
            to_date: toDate,
          }
        );


        setDeposits(response.data.deposits || []);
      } catch (err) {
        console.error("Error fetching deposits:", err);
        setError("Failed to fetch deposit ledger.");
      } finally {
        setLoading(false);
      }
    };

    fetchDeposits();
  }, [username, fromDate, toDate]);

  if (loading) {
    return <p>लोड होत आहे...</p>;
  }

  if (error) {
    return <p style={{ color: "red" }}>{error}</p>;
  }

  return (
    <div style={{ padding: "10px" }}>
      <h3 style={{ marginBottom: "10px" }}>ठेव जमा नोंदी</h3>
      {deposits.length === 0 ? (
        <p>नोंदी उपलब्ध नाहीत.</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ backgroundColor: "#f2f2f2" }}>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                दिनांक (From - To)
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                रक्कम (₹)
              </th>
              <th style={{ border: "1px solid #ccc", padding: "8px" }}>
                नोंद
              </th>
            </tr>
          </thead>
          <tbody>
            {deposits.map((entry, index) => (
              <tr key={index}>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {new Date(entry.bill_fromdate).toLocaleDateString("en-GB")} -{" "}
                  {new Date(entry.bill_todate).toLocaleDateString("en-GB")}
                </td>

                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {entry.deposit_kapat || 0}
                </td>
                <td style={{ border: "1px solid #ccc", padding: "8px" }}>
                  {entry.narration || "बिल कपात - ठेव"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default DepositLedgerTab;
